@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent" [title]="component.alias"
    [icon]="{name: 'power-outline', size: 'large', color: 'normal'}">
    <oe-flat-widget-line [name]="'GENERAL.CURRENT_STATUS' | translate" [value]="state"></oe-flat-widget-line>
  </oe-flat-widget>
}